import { Button, Card, Form, InputNumber, message, Select } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { SaveOutlined, PercentageOutlined, CarOutlined, CreditCardOutlined } from '@ant-design/icons';
import TextArea from 'antd/es/input/TextArea';
import axios from 'axios';
import { usePos } from './PosStore';
import { useForm } from 'antd/es/form/Form';

const sectionStyle = { marginBottom: 14 };

const ParamsForm = () => {
    let [customers, setCustomers] = useState([])
    let { setDisType, checkDiscount, checkDeliverSumm, newSales, checkPayAmount } = usePos()
    const fetchCustomers = useCallback(async () => {
        try {
            const response = await axios.get('customers');
            setCustomers(response.data);
        } catch (error) {
            message.error("Xaridorlarni yuklashda xatolik yuz berdi");
            console.error("Xaridorlarni yuklashda xatolik:", error);
        }
    }, []);

    let [form] = useForm()

    useEffect(() => {
        fetchCustomers()
    }, [fetchCustomers])

    // Customer options useMemo orqali hisoblash
    const customerOptions = useMemo(() => {
        return customers.map(item => ({
            value: item.id,
            label: item.first_name + ' ' + item.last_name
        }));
    }, [customers]);

    return (
        <Form form={form} layout='vertical' onFinish={(values) => { newSales(values, form) }}>
            <Card
                size="small"
                style={sectionStyle}
                title={<span><PercentageOutlined style={{ color: 'var(--primary)', marginRight: 8 }} />Chegirma</span>}
            >
                <Form.Item name="distype" label="Chegirma turi" style={{ marginBottom: 12 }}>
                    <Select
                        placeholder="Turi"
                        onChange={(value) => setDisType(value)}
                        options={[
                            { value: 'sum', label: 'Summa (so\'m)' },
                            { value: 'percent', label: 'Foiz (%)' },
                        ]}
                    />
                </Form.Item>
                <Form.Item name="discount" label="Chegirma miqdori" style={{ marginBottom: 0 }}>
                    <InputNumber style={{ width: '100%' }} min={0} controls={false} onChange={(v) => checkDiscount(v ?? 0)} />
                </Form.Item>
            </Card>

            <Card
                size="small"
                style={sectionStyle}
                title={<span><CarOutlined style={{ color: 'var(--primary)', marginRight: 8 }} />Yetkazib berish</span>}
            >
                <Form.Item name="deliverysumm" label="Yetkazish narxi" style={{ marginBottom: 12 }}>
                    <InputNumber style={{ width: '100%' }} min={0} controls={false} onChange={(v) => checkDeliverSumm(v ?? 0)} />
                </Form.Item>
                <Form.Item
                    name="deliveraddress"
                    label="Yetkazish manzili"
                    style={{ marginBottom: 0 }}
                    rules={[{ type: 'string', min: 5, message: "Manzil kamida 5 ta belgidan iborat bo'lishi kerak" }]}
                >
                    <TextArea rows={3} placeholder="Manzilni kiriting..." />
                </Form.Item>
            </Card>

            <Card
                size="small"
                style={sectionStyle}
                title={<span><CreditCardOutlined style={{ color: 'var(--primary)', marginRight: 8 }} />To'lov</span>}
            >
                <Form.Item name={'customer_id'} label='Xaridor' style={{ marginBottom: 12 }} rules={[{ required: true, message: 'Iltimos xaridorni tanlang' }]}>
                    <Select showSearch optionFilterProp="label" placeholder="Xaridorni tanlang" options={customerOptions} />
                </Form.Item>
                <Form.Item name={'naqd'} label="Naqd" style={{ marginBottom: 12 }}>
                    <InputNumber style={{ width: '100%' }} min={0} controls={false} onChange={(v) => checkPayAmount(v ?? 0, 'naqd')} />
                </Form.Item>
                <Form.Item name={'plastik'} label="Plastik" style={{ marginBottom: 12 }}>
                    <InputNumber style={{ width: '100%' }} min={0} controls={false} onChange={(v) => checkPayAmount(v ?? 0, 'plastik')} />
                </Form.Item>
                <Form.Item name={'boshqa'} label="Boshqa" style={{ marginBottom: 0 }}>
                    <InputNumber style={{ width: '100%' }} min={0} controls={false} onChange={(v) => checkPayAmount(v ?? 0, 'boshqa')} />
                </Form.Item>
            </Card>

            <Button
                size='large'
                type='primary'
                htmlType='submit'
                icon={<SaveOutlined />}
                block
            >
                Sotuvni saqlash
            </Button>
        </Form>
    );
};

export default ParamsForm;
